module.exports = __webpack_public_path__ + "cd4deffc8729b84815f708c59d2cc89a.svg";